/** @jsx h */
import { useEffect, useRef, useState } from 'preact/hooks';
import Datepicker from '../../../macros/datepicker/datepicker';
import { getFormattedDate } from '../helpers/helpers';
import { labels } from '../config';

const DatePicker = ({
  facet,
  triggerAjaxSubmit,
  pluginNamespace,
  datepickerFilter,
  resetFn,
}) => {
  const refInput = useRef(null);
  const refDialog = useRef(null);
  const [datePicker, setDatePicker] = useState(null);

  useEffect(() => {
    if (resetFn) {
      datePicker.resetActiveDate();
    }
  }, [resetFn]);

  useEffect(() => {
    if (refDialog && refInput) {
      const datepickerInput = refInput.current;
      const datePickerClass = new Datepicker({
        inputNode: refInput.current,
        dialogNode: refDialog.current,
        disablePastDates: false,
        disablePastMonths: true,
        firstDayOfWeek: 'mon',
        onDaySet: date => {
          const dateValue = getFormattedDate(
            date,
            'dateRange:___FROM___-___TO___'
          );
          datepickerInput.value = dateValue; // update input value
          triggerAjaxSubmit();
        },
      });
      datePickerClass.init();
      setDatePicker(datePickerClass);
    }
  }, []);

  useEffect(() => {
    if (datepickerFilter) {
      const datepickerInput = refInput.current;
      datepickerInput.value = datepickerFilter; // update input value
      datePicker.resetActiveDate();
      triggerAjaxSubmit();
    }
  }, [datepickerFilter]);

  return (
    <div class="datepicker">
      <div class="datepicker__date">
        <label for="id-textbox-1">Date</label>
        <input
          ref={refInput}
          type="text"
          placeholder="dd.mm.yyyy"
          id="id-textbox-1"
          class="datepicker__input"
          data-value={`${facet.name}:___FROM___-___TO___`}
          name={`${pluginNamespace}[filter][]`}
          aria-autocomplete="none"
        />
      </div>
      <div
        class="datepicker__dialog"
        aria-labelledby="id-dialog-label"
        ref={refDialog}
      >
        <div class="datepicker__header">
          <button
            class="datepicker__button datepicker__prev-year"
            type="button"
            aria-label={labels.datePicker.previousYear}
            hidden
          >
            <i class="datepicker__icon icon-arrow-left" aria-hidden="true" />
            <span class="sr-only">{labels.datePicker.previousYear}</span>
          </button>
          <button
            class="datepicker__button datepicker__prev-month"
            type="button"
            aria-label={labels.datePicker.previousMonth}
          >
            <i class="datepicker__icon icon-arrow-left" aria-hidden="true" />
            <span class="sr-only">{labels.datePicker.previousMonth}</span>
          </button>
          <h2
            id="id-dialog-label"
            class="datepicker__month-year"
            aria-live="polite"
          />
          <button
            class="datepicker__button datepicker__next-month"
            type="button"
            aria-label={labels.datePicker.nextMonth}
          >
            <i class="datepicker__icon icon-arrow-right" aria-hidden="true" />
            <span class="sr-only">{labels.datePicker.nextMonth}</span>
          </button>
          <button
            class="datepicker__button datepicker__next-year"
            type="button"
            aria-label={labels.datePicker.nextYear}
            hidden
          >
            <i class="datepicker__icon icon-arrow-left" aria-hidden="true" />
            <span class="sr-only">{labels.datePicker.nextYear}</span>
          </button>
        </div>
        <table
          id="myDatepickerGrid"
          class="datepicker__dates"
          role="grid"
          aria-labelledby="id-dialog-label"
        >
          <thead />
          <tbody />
        </table>
      </div>
    </div>
  );
};

export default DatePicker;
